import { render, staticRenderFns } from "./Cooperate.vue?vue&type=template&id=5d9710de&scoped=true&"
import script from "./Cooperate.vue?vue&type=script&lang=js&"
export * from "./Cooperate.vue?vue&type=script&lang=js&"
import style0 from "./Cooperate.vue?vue&type=style&index=0&id=5d9710de&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d9710de",
  null
  
)

export default component.exports